import type React from 'react'

import { type ChannelId } from '@onr/schema'
import { useNavigate, useParams } from '@tanstack/react-router'

import { Toaster } from '@/components/molecules/Toaster'
import { TeamConversationView } from '@/components/templates/TeamConversationView/TeamConversationView.tsx'
import { RegionProvider } from '@/model/contexts/RegionProvider'

import { useTeamMessagesPage } from './useTeamMessagesPage.ts'

const TeamMessagesPageContent: React.FC = () => {
  const props = useTeamMessagesPage()
  const { regionId, teamId } = useParams({ from: '/dashboard/$regionId/messages/$teamId' })
  const navigate = useNavigate()

  const onTeamMessageClick = (clickedTeamId: string) =>
    navigate({ to: '/dashboard/$regionId/messages/$teamId', params: { regionId, teamId: clickedTeamId } })

  const onHighlight = (transportRequestId: string) => navigate({ to: '/', search: { transportRequestId } })

  const onChannelMessageClick = (channelId: ChannelId) =>
    navigate({ to: '/dashboard/$regionId/messages/channels/$channelId', params: { regionId, channelId } })

  return (
    <>
      <Toaster
        onHighlight={onHighlight}
        onTeamMessageClick={onTeamMessageClick}
        currentTeamId={teamId}
        onChannelMessageClick={onChannelMessageClick}
      />
      <TeamConversationView {...props} />
    </>
  )
}

export const TeamMessagesPage: React.FC = () => {
  const { regionId } = useParams({ from: '/dashboard/$regionId/messages/$teamId' })

  return (
    <RegionProvider regionId={regionId}>
      <TeamMessagesPageContent />
    </RegionProvider>
  )
}
